import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import '../styles/Admin.css';
import { LayoutDashboard, Users, TrendingUp, LogOut, Menu, X, ChevronRight, CreditCard, FolderOpen, Award } from 'lucide-react';


const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('mstechs_token');
    if (!token) {
      navigate('/mstechs');
      return;
    }
    verifyAuth(token);
  }, [navigate]);

  const verifyAuth = async (token) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/verify`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setAdmin(data.admin);
      } else {
        handleLogout();
      }
    } catch (err) {
      handleLogout();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('mstechs_token');
    navigate('/mstechs');
  };

  const navItems = [
  { path: '/mstechs/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/mstechs/clients', icon: Users, label: 'Klijenti' },
  { path: '/mstechs/payments', icon: CreditCard, label: 'Uplate' },
  { path: '/mstechs/income', icon: TrendingUp, label: 'Prihodi' },
  { path: '/mstechs/projects', icon: FolderOpen, label: 'Projekti' },
  { path: '/mstechs/logos', icon: Award, label: 'Logoi' }
];

  const getPageTitle = () => {
    const item = navItems.find(nav => nav.path === location.pathname);
    return item ? item.label : 'Admin Panel';
  };

  return (
    <div className="admin-layout">
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'collapsed'} ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <span className="logo-text">MS</span>
            {sidebarOpen && <span className="logo-accent">Tech</span>}
          </div>
          <button className="sidebar-toggle desktop-only" onClick={() => setSidebarOpen(!sidebarOpen)}>
            <ChevronRight className={`toggle-icon ${!sidebarOpen ? 'rotated' : ''}`} />
          </button>
          <button className="sidebar-close mobile-only" onClick={() => setMobileMenuOpen(false)}>
            <X size={24} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              <item.icon size={22} />
              {sidebarOpen && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-logout" onClick={handleLogout}>
            <LogOut size={22} />
            {sidebarOpen && <span>Odjava</span>}
          </button>
        </div>
      </aside>

      {mobileMenuOpen && <div className="sidebar-overlay" onClick={() => setMobileMenuOpen(false)} />}

      <main className={`admin-main ${sidebarOpen ? '' : 'expanded'}`}>
        <header className="admin-header">
          <div className="header-left">
            <button className="mobile-menu-btn mobile-only" onClick={() => setMobileMenuOpen(true)}>
              <Menu size={24} />
            </button>
            <h1 className="header-title">{getPageTitle()}</h1>
          </div>
          <div className="header-right">
            {admin && (
              <div className="header-user">
                <div className="user-avatar">{admin.username.charAt(0).toUpperCase()}</div>
                <span className="user-name">{admin.username}</span>
              </div>
            )}
          </div>
        </header>

        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;